<template>
    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Spouse Information</div>
            <template v-if="showList.length == 0">
                <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" @click="addNew()"><button
                        class="edit-icon bank-info-edit"><i class="fa fa-plus"></i></button></div>
            </template>
        </div>

        <b-overlay :show="showoverlay_list" rounded="sm">
            <div v-if="spouse_list.length > 0">
                <div class="bank-info-inner" v-for="spouse in showList" :key="spouse.id">
                    <ul class="bank-info border-top">
                        <li class="px-4">
                            <div class="title col-6">Name</div>
                            <div class="text col-5">{{ spouse.name }}</div>

                            <div class="action col-1">
                                <b-button-toolbar class="float-right position-relative">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                        <b-button-group class="mt-n2">
                                            <b-button class="border-0 rounded py-0" variant="outline-secondary"
                                                title="Edit spouse Info" @click="editSpouseData(spouse.id)">
                                                <b-icon icon="pencil-fill" aria-hidden="true"></b-icon> Edit
                                            </b-button>
                                            <b-button class="border-0 rounded py-0" variant="outline-secondary"
                                                title="Delete spouse Info" @click="deleteSpouseData(spouse.id)">
                                                <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>
                        </li>
                        <li class="px-4">
                            <div class="title col-6">Gender</div>
                            <div class="text col-6"><template
                                    v-if="spouse.gender != 'null'">{{ spouse.gender }}</template></div>
                        </li>
                        <li class="px-4">
                            <div class="title col-6">Date of Birth</div>
                            <div class="text col-6"><template
                                    v-if="spouse.dob != 'null'">{{ spouse.date_of_birth }}</template>
                            </div>
                        </li>
                    </ul>

                </div>

                <!--<template v-if="spouse_list.length > 0">
                    <div class="more-bank">
                        <b-button class="border-0 rounded p-0" variant="outline-secondary" :title="direction_title" @click="toggleDirection">
                            {{direction_title}} <i class="fa " :class="direction_class"></i>
                        </b-button>
                    </div>
                </template>-->
            </div>
            <div v-else>
                <div class="bank-info-inner px-4 ">
                    <p>No spouse information available.</p>
                </div>
            </div>
        </b-overlay>


        <b-modal id="bv-modal-spouseform" size="lg" hide-footer title="Spouse Info">
            <b-form @submit.stop.prevent="onSubmit">
                <ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='(data, n) in errormsg' :key="n">{{ data[0] }}
                    </li>
                </ul>

                <input type="hidden" v-model="fdata.id" name="id">
                <div class="clearfix">
                    <div class="col-md-6 float-left">
                        <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                            <b-form-input id="name" name="name" v-model="fdata.name"
                                v-validate="{ required: true, min: 3, alpha_spaces: true }" :state="validateState('name')"
                                aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="gender-group" label="Gender" class="required-field" label-for="gender">
                            <b-form-select id="gender" name="gender" v-model="fdata.gender" :options="genders"
                                v-validate="{ required: true }" :state="validateState('gender')"
                                aria-describedby="gender-feedback" data-vv-as="Gender"></b-form-select>
                            <b-form-invalid-feedback id="gender-feedback">{{ veeErrors.first('gender')
                                }}</b-form-invalid-feedback>
                        </b-form-group>


                    </div>
                    <div class="col-md-6 float-right">

                        <b-form-group id="date_of_birth-group" label="Date of Birth [YYYY-MM-DD]" class="required-field"
                            label-for="date_of_birth">
                            <b-input-group class="">
                                <b-form-input id="date_of_birth" name="date_of_birth" v-model="fdata.date_of_birth"
                                    v-validate="{ required: true, date_format: 'yyyy-MM-dd' }" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_of_birth')"
                                    aria-describedby="date_of_birth-feedback" data-vv-as="Date of Birth"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker id="date_of_birth" button-only right locale="en-US" :max="new Date()"
                                        v-model="fdata.date_of_birth"></b-form-datepicker>
                                </b-input-group-append>

                            </b-input-group>
                            <b-form-invalid-feedback force-show v-if="veeErrors.has('date_of_birth')">
                                {{ veeErrors.first('date_of_birth') }}
                            </b-form-invalid-feedback>
                        </b-form-group>

                    </div>
                    <div class="mt-4 col-md-12 float-left">
                        <b-button type="submit" class="border rounded float-right py-1 px-5 mt-4 ml-2"
                            variant="primary">Submit</b-button>
                        <b-button class="ml-2 border rounded float-right py-1 px-5 mt-4" variant="primary"
                            @click="resetForm()">Reset</b-button>
                    </div>
                </div>

            </b-form>
        </b-modal>



    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: ['flg'],
    data() {

        return {

            successmsg: '',
            errormsg: [],

            fdata: { name: null, id: null, gender: null, date_of_birth: null, dependent_type: 'spouse' },

            spouse_list: [],

            genders: [
                { value: null, text: "Select..." },
                { value: "Male", text: "Male" },
                { value: "Female", text: "Female" },
                { value: "Third Gender", text: "Third Gender" },
            ],

            direction: true,
            direction_class: 'fa-angle-down',
            direction_title: 'Show All',


            showoverlay_list: false,
        }
    },
    methods: {
        toggleDirection: function () {
            this.direction = !this.direction;
        },
        showLessMore: function (data, direction) {
            if (direction) {
                this.direction_class = 'fa-angle-down';
                this.direction_title = 'Show All';
                return data.slice(0, 1);
            }
            else {
                this.direction_class = 'fa-angle-up';
                this.direction_title = 'Show Less';

                return data;
            }
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { name: null, id: null, gender: null, date_of_birth: null, dependent_type: 'spouse' };
            this.$nextTick(() => {
                this.$validator.reset();
            });

        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-spouseform');
        },
        getSpouseData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/front/spouse/list', {
                params: {

                }
            }).then(function (response) {
                this.spouse_list = response.data;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        editSpouseData: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.errormsg = [];
            this.successmsg = '';


            axios.get(this.$api_url + '/front/spouse/details?id=' + x, {
                params: {

                }
            }).then(function (response) {
                this.fdata = response.data;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

            this.$bvModal.show('bv-modal-spouseform');

        },
        deleteSpouseData: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to Remove?', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        let currentObj = this;

                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/front/spouse/delete', formData).then(function (response) {

                            this.$bvToast.toast('Spouse data deleted successfully', {
                                title: `Data Deleted`,
                                variant: 'success',
                                solid: true
                            });

                            this.getSpouseData();

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.serverError(error);
                            });
                    }
                })
                .catch(err => {
                    currentObj.serverError(error);
                })
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/front/spouse/details', formData)
                    .then(function (response) {
                        this.agents = response.data;
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-spouseform');

                        this.resetForm();

                        this.getSpouseData();

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                    });
            });
        },


    },
    created: function () {

        this.getSpouseData();
    },
    computed:
    {
        showList() {
            return this.showLessMore(this.spouse_list, this.direction);
        }
    }
}
</script>
